// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c7cda3cc","160":"42030423","208":"76f0b050","293":"171d1f22","516":"647a49bc","519":"883b295a","917":"bcf52a6c","946":"35017d65"}[chunkId] + ".chunk.js";
};